import { useState, useRef } from 'preact/hooks'
import type { ChatConfig, UiTexts } from '../../types/chat'
import styles from './ChatInput.module.css'

interface Props {
  config: ChatConfig
  texts: UiTexts
  onSend: (text: string) => void
}

export default function ChatInput({ config, texts, onSend }: Props) {
  const [value, setValue] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)

  // Enter submits the form natively (also respects IME composition).
  function handleSubmit(e: Event) {
    e.preventDefault()
    const trimmed = value.trim()
    if (!trimmed) return
    onSend(trimmed)
    setValue('')
    inputRef.current?.focus()
  }

  const sendLabel = config.sendButtonText ?? texts.send

  return (
    <form className={styles.form} data-part="form" onSubmit={handleSubmit}>
      <input
        ref={inputRef}
        type="text"
        className={styles.input}
        data-part="input"
        value={value}
        onInput={(e) => setValue((e.target as HTMLInputElement).value)}
        placeholder={config.placeholder ?? texts.placeholder}
        aria-label={texts.inputLabel}
        autoComplete="off"
        enterKeyHint="send"
        maxLength={2000}
      />
      <button type="submit" className={styles.sendBtn} data-part="send" disabled={!value.trim()} aria-label={sendLabel}>
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
          <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
        </svg>
        {sendLabel}
      </button>
    </form>
  )
}
